import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const PinIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="pin" ref={ref as any} {...props}>
      <path
        d="M6.701 15.348h4.55v4.306c0 1.274.545 2.346.758 2.346.204 0 .75-1.072.75-2.346v-4.306h4.54c.588 0 1.014-.368 1.014-.93 0-.351-.111-.603-.358-.862l-2.607-2.782c-.179-.184-.29-.318-.247-.662l.434-3.057c.026-.176.043-.277.205-.386l2.087-1.49c.468-.336.673-.746.673-1.123C18.5 3.494 18.04 3 17.384 3H6.616C5.96 3 5.5 3.494 5.5 4.056c0 .377.204.787.664 1.122L8.26 6.67c.162.11.179.21.205.386l.434 3.057c.051.344-.068.478-.247.662l-2.607 2.782c-.247.26-.358.51-.358.862 0 .562.426.93 1.014.93ZM7.81 14c-.077 0-.128-.05-.128-.126 0-.05.034-.1.077-.143l2.18-2.245c.281-.276.392-.578.358-.888L9.768 6.56c-.043-.326-.153-.57-.4-.737L7.519 4.617c-.06-.042-.077-.084-.077-.143 0-.075.06-.125.137-.125h8.842c.077 0 .137.05.137.125 0 .06-.017.1-.077.143l-1.849 1.206c-.247.168-.357.41-.4.737l-.528 4.038c-.034.31.076.612.35.888l2.188 2.245a.205.205 0 0 1 .069.143c0 .075-.043.126-.12.126H7.81Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
